const BASE_URL = process.env.REACT_APP_BASE_URL;

// AUTH ENDPOINTS
export const endpoints = {
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  REGISTER_API: BASE_URL + "/auth/register",
  SIGNUP_API: BASE_URL + "/auth/signup",

  SIGNIN_API: BASE_URL + "/auth/signin",
  CHANGE_PASSWORD_API: BASE_URL + "/auth/change-password",

  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",

  SEND_EMAIL_OTP_API: BASE_URL + "/auth/sendotp-email",
  VERIFY_EMAIL_OTP_API: BASE_URL + "/auth/verifyotp-email",

  UPDATE_IMAGE_API: BASE_URL + "/auth/update-image",
  UPDATE_INFO_API: BASE_URL + "/auth/update-info",

  GET_USER_DETAILS_API: BASE_URL + "/auth/get-user-details",
  GET_ALL_USERS_API: BASE_URL + "/auth/get-all-user-details",
  EDIT_USER_API: (userId) => `${BASE_URL}/auth/edit-user/${userId}`,
  DELETE_USER_API: (userId) => `${BASE_URL}/auth/delete-user/${userId}`,
};

export const airecord = {
  GET_ALL_RECORD_API: BASE_URL + "/ai-records",
  GET_RECORD_BY_ID_API: (id) => `${BASE_URL}/ai-records/${id}`,
  UPDATE_REPORT_API: BASE_URL + "/ai-records/add-doctor-report",
  // DELETE_SPEAKER_API: (id) => `${BASE_URL}/speakers/${id}`,
  // CREATE_SPEAKER_API: BASE_URL + "/speakers",
};

export const chatbotendpoints = {
  CHATBOT_API: BASE_URL + "/chatbot",
};

export const documentAnalysisEndpoints = {
  ANALYZE_DOCUMENT_API: BASE_URL + "/document-analysis/analyze",
  ANALYSIS_HISTORY_API: BASE_URL + "/document-analysis/history",
};


